import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@emotion/react';
import { CustomBtn } from '../button/button';
import { Subject, Inventory, Receipt, Remove, WrongLocation, StopCircle, Delete } from "@mui/icons-material";
import { IconButton } from '@mui/material';
import { IconCross, IconCrossOff } from '@tabler/icons';

export default function SimpleTableFees({ removeRec, data }) {
  const getDate = (value) => {
    const cleanValue = value?.replace(/(\d+)(st|nd|rd|th)/, '$1');
    const event = new Date(cleanValue);

    if (isNaN(event.getTime())) return value; 
    const locale = 'fa-IR';
    if (locale === 'fa-IR') {
      const arr = ['دی', 'بهمن', 'اسفند', 'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر'];
      const convertmonths = ['جدی', 'دلو', 'حوت', 'حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس'];
      const getMonth = event.toLocaleDateString(locale, { month: 'long' });
      const currentDate = event.toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
      const getIndMonth = arr.indexOf(getMonth);
      return currentDate.replace(getMonth, convertmonths[getIndMonth]);
    }

    return event.toLocaleDateString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const theme = useTheme();
  const style = theme.palette;

  const deleteRecord = (record) => { 
    removeRec(record); // send back record to parent
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 515 }} aria-label="caption table">
        <TableHead>
          <TableRow sx={{ background: style.primary.main }} id="thead">
            {data &&
              Object.keys(data[0]).map((key) => (
                <TableCell key={key} sx={{ color: style.sidemenutext.color }}>
                  {key === 'Month'
                    ? 'Month'
                    : key === 'roll'
                    ? 'Roll Num.'
                    : key === 'Srn'
                    ? 'Srn.'
                    : key === 'Date'
                    ? 'Date'
                    : key === 'Fees'
                    ? 'Fees'
                    : key === 'Discount'
                    ? 'Discount'
                    : key === 'StudentSrn'
                    ? 'Roll Number'
                    : key === 'StartDate'
                    ? 'Start Date'
                    : key === 'Comments'
                    ? 'Comments'
                    : key === 'paidFees'
                    ? 'Paid Fees'
                    : key === 'Description'
                    ? 'Description'
                    : key === 'Dues'
                    ? 'Dues'
                    : key === 'Paid Amount'
                    ? 'Paid Amount'
                    : key === 'NamePashto'
                    ? 'Name'
                    : key === 'FNamePashto'
                    ? 'Father Name'
                    : key === 'TellNo1'
                    ? 'Mobile'
                    : key === 'Ammount'
                    ? 'Amount'
                    : null}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map((row, ind) =>
              row.Description === 'Total' ? (
                <TableRow key={ind}>
                  {Object.values(row).map((value, index) => (
                    <TableCell key={index}>
                      <b>{value}</b>
                    </TableCell>
                  ))}
                </TableRow>
              ) : (
                <TableRow key={ind}>
                  {Object.entries(row).map(([key, value], index) => (
                    <TableCell key={index}>
                      {key === 'Date' ? (
                        <>
                          <span style={{ fontSize: '14px' }}>{getDate(value)}</span>
                          <br />
                          {value}
                        </>
                      ) : key === 'Srn' ? (
                        <>
                          {value}
                          <br />
                          <IconButton size="small" onClick={() => deleteRecord(value)}>
                            <Delete fontSize="small" />
                          </IconButton>
                        </>
                      ) : (
                        value
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              )
            )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
